import styleInject from '../../node_modules/style-inject/dist/fb3a8d84bb477a96e56a5e12f7d7ac81b9d9799a9277fe852d93ab86a1b81224.cfe-internal.js';

var css_248z = "._2M-3n{font-size:14px}._2kFMm{color:#6a6d70;line-height:20px;display:inline-flex;flex-direction:column;align-items:flex-start}._aO8RX{color:#0b6ed0}";
var styles = {"label":"_2M-3n","control":"_2kFMm","focused":"_aO8RX"};
var stylesheet="._2M-3n{font-size:14px}._2kFMm{color:#6a6d70;line-height:20px;display:inline-flex;flex-direction:column;align-items:flex-start}._aO8RX{color:#0b6ed0}";
styleInject(css_248z);

export { styles as default, stylesheet };
